import * as _ from 'lodash';
import classnames from 'classnames';
import type { VoidFunctionComponent } from 'react';
import { STATUS } from '../../../../shared/issuesV2';
import useStatusSummary from './hooks/useStatusSummary';
import { ignoreOrResolveWordPast, truncateNumber } from '../../../utils';

/**
 * IssueStatusTabs is the tabs component for the user
 * to navigate between different "statuses" an issue can
 * be in: "active" | "ignored".
 *
 * See the useStatusSummary hook, which manages the actions
 * for getting the status summary and updating the active status.
 */
const IssueStatusTabs: VoidFunctionComponent = () => {
  const {
    status: activeStatus,
    setStatus,
    isLoading,
    statusSummary,
  } = useStatusSummary();
  return (
    <ul className="issues-inbox__issue-status-tabs">
      {STATUS.map(status => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- Note that these will be addressed in the future when we make a generic a11y tabs component.
        <li
          key={status}
          className={classnames('issues-inbox__issue-status-tabs__item', {
            'issues-inbox__issue-status-tabs__item--active': status === activeStatus,
          })}
          onClick={() => setStatus(status)}
          data-test-id={`issues-inbox-status-tab--${status}`}
        >
          <span>
            {_.capitalize(status === 'ignored' ? `${ignoreOrResolveWordPast()}` : status)}
          </span>
          <span className="badge margin-left-xs">
            {(isLoading || !statusSummary)
              ? '...'
              : truncateNumber(statusSummary?.issues?.[status])}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default IssueStatusTabs;
